// extracted by mini-css-extract-plugin
module.exports = {"truncable":"_1pyhVQHb","info":"_1RayIiMM","paginationBar":"_1H642yM3","emptyResults":"_2kAIkYxc"};